export interface FileTypeType extends Record<string, any> {
  key: string,
  message: string
}

const FileType: Record<string, FileTypeType> = {
  INSPECTION_SUMMARY: {key: 'INSPECTION_SUMMARY', message: 'file.type.inspection.summary'},
  ACTION_SUMMARY: {key: 'ACTION_SUMMARY', message: 'file.type.action.summary'},
  REPORT: {key: 'REPORT', message: 'file.type.report'},
  UNKNOWN: {key: 'UNKNOWN', message: 'file.type.unknown'},
}
export default FileType;
